// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".under-line-input-content_select_popper .el-select-dropdown__item{font-size:1.25rem;text-align:center!important}.correct_answer{color:#1ac36e!important}.error_answer{color:red!important}", ""]);
// Exports
module.exports = exports;
